"use client";
import React from "react";
import Head from "next/head";
import PriceSetups from "././_pricesFeatures/PriceSetups";
import ShopAddressPart from "./././_shopAddress/ShopAddressPart";
import { faCog } from "@fortawesome/pro-solid-svg-icons";
import PageInformationCard from "~/components/PageInformationCard.jsx";
import { ROUTES } from "~/constants";
import TurnrLink from "~/components/links/TurnrLink";
import { TurnrText } from "~/components/TurnrText.jsx";
import BrandNeededWrapper from "~/components/BrandNeededWrapper.jsx";
import { getSelectedBrandName } from "~/cores/appCore";
import { ReturnAppLinkWithCopy } from "~/components/links/ReturnAppLink.jsx";
import { useAppProps } from "~/app/_apps/AppPropsContext";

export default function SettingsPriceSetupsPage() {
    const { appProps } = useAppProps();

    const { getShopAddressesServiceData, clearShopAddressesServiceData } = appProps;

    const shopAddressesServiceData = getShopAddressesServiceData();

    function onSuccess() {
        clearShopAddressesServiceData();
    }

    return (
        <>
            <Head>
                <title>Return settings</title>
            </Head>
            <PageInformationCard
                iconProps={{ flip: "horizontal" }}
                icon={faCog}
                title={"Price Setups"}
                content={
                    <TurnrText size={"sm"}>
                        Here you decide what return options a customer will be provided when making a return. You can offer different settings based on <b>customer country</b> and <b>product type</b>.
                        <br /> You can change return & exchange prices, what shipment methods are offered, presented currency and much more.
                        <br />
                        <br />
                        You probably want to take a look <TurnrLink href={ROUTES.INTEGRATIONS_SHIPMENT}>Shipment integrations</TurnrLink> before configuring your price setups.
                    </TurnrText>
                }
            />
            <BrandNeededWrapper appProps={appProps}>
                {getSelectedBrandName(appProps) && (
                    <div style={{ width: "fit-content" }} className={"mb2"}>
                        <ReturnAppLinkWithCopy
                            appProps={appProps}
                            tooltipContent={
                                "When making changes we recommend that you create a test order in your system and make a return in the Return Portal and see how it would look like for a customer"
                            }
                        />
                    </div>
                )}
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <>
                        <PriceSetups appProps={appProps} shopAddressesServiceData={shopAddressesServiceData} />
                        <div className={"mt3"} style={{ maxWidth: "870px" }}>
                            <ShopAddressPart appProps={appProps} shopAddressesServiceData={shopAddressesServiceData} onSuccess={onSuccess} />
                        </div>
                    </>
                </div>
            </BrandNeededWrapper>
        </>
    );
}
